import { useEffect, useState } from "react";
import Slider from "react-slick";
import { getTopper } from "../Service/Api";
import LazyLoad from "react-lazyload";
const TopperX = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const topperData = await getTopper();
        setData(topperData);
      } catch (error) {
        console.error("Error fetching topper data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    
  }, [data]);

  const emptyArray = [
       {name:"Student Name",per:"90%"},
       {name:"Student Name",per:"90%"}
  ];
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <Slider {...settings}>
          {data.filter((item) => item.class === "X").length > 0
          ? data
              .filter((item) => item.class === "X")
              .map((item, index) => (
                <div className="item" key={index}>
                <div className="topperdiv">
                <div className="star">
                        {item.division}
                </div>
                <div className="toppertaj">
                  <LazyLoad offset={10} placeholder={<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/dummy.jpg" alt="Loading..." className="img-fluid"/>}>
                    <img src={item.attachments && item.attachments[0] ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}` : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/dummy.jpg"} className="img-fluid"/>
                  </LazyLoad>
                </div>
                <div className="topperdesc">
                  <p className="name"> {item.name}</p> 
                </div>
            </div> 
            </div>
              ))
              : emptyArray.map((data,index) => (
                <div className="item" key={index}>
                <div className="topperdiv">
                          <div className="star">
                                  {data.per}
                          </div>
                          <div className="toppertaj">
                            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/dummy.jpg" className="img-fluid" /></LazyLoad>
                          </div>
                          <div className="topperdesc">
                            <p className="name"> {data.name}</p> 
                          </div>
                  </div>  
                </div>
              ))}   
 
      </Slider>
    </>
  );
};

export default TopperX;
